import { Injectable } from "@angular/core";
import { FaceId } from "../model/face-id.model";
import { FaceIdApi } from "./face-id.api";

@Injectable({
    providedIn: 'root'
})
export class FaceIdRepository {

    public faceId: FaceId = null;

    constructor(private faceIdApi: FaceIdApi) {
    }

    setFaceId(faceId: FaceId) {
        this.faceId = faceId;
    }

    getFaceId() {
        return this.faceId;
    }

    async fetchFaceId() {
        const res = await this.faceIdApi.read();
        if (res && res.data) {
            this.faceId = res.data;
            return this.faceId;
        }
        return null;
    }
}